export default "https://assets.egbcdn.net/assets/packs/_/images/beer/therese_von_bayern/beer-vessel-c048d058ca0e325f2b6e61aed1cd8d04.png";